module.exports = __webpack_public_path__ + "img/intro-screen-bg-grey.a2b79786.png";